const regex = /\${[^{]+}/g;

const priceFormat = new Intl.NumberFormat('de-DE', {
  style: 'currency',
  currency: 'EUR',
});

export function interpolate(template: string, variables: any) {
  return template.replace(regex, (match) => {
    const key = match.slice(2, -1).trim();
      return variables[key] || '';
  });
}

export function formatPrice(value: number) {
  return priceFormat.format(value);
}

export function currencyParts(amount: number) : string[] {
  const money = amount.toFixed(2).toString();
  return money.split('.');
}

export function formatDate(value: string): string {
  let dateParts = value.substr(0, 10).split('-');
  dateParts.reverse();
  dateParts[0].replace('0', '');
  dateParts[1].replace('0', '');
  return dateParts.join('.');
}
export function formatDateWithoutDate(value: string): string {
    let dateParts = value.substr(0, 10).split('-');
    dateParts.reverse();
    dateParts[0].replace('0', '');
    dateParts[1].replace('0', '');
    dateParts.shift();
    return dateParts.join('.');
}

export function isExpansionPeriodEndInFuture(value: string): boolean {
    return new Date().getTime() <= new Date(value).getTime();
}
export function formatDateWithTwoDigitsInYear(value: string): string {
    let dateParts = value.substr(0, 10).split('-');
    dateParts.reverse();
    dateParts[2] = dateParts[2].substr(2);
    return dateParts.join('.');
}
export function getMonthName(date: Date) : string{
  const options = {
    month: 'long',
  };
  return date.toLocaleString('de-DE', options);
}
export function formateDateWithMonthNameAndYear(value: string): string{
  const d = new Date(value);
  return getMonthName(d) + ' ' + d.getFullYear();
}
